<template>
  <div>
    <vx-card>
      <ListTiposFornecedor :dados="dados"></ListTiposFornecedor>
    </vx-card>
  </div>
</template>

<script>
import service from "../../../services";
import ListTiposFornecedor from "./../../lists/ListTiposFornecedor";

export default {
  components: {
    ListTiposFornecedor
  },

  data() {
    return {
      dados: {}
    };
  },

  methods: {
    getDados() {
      this.$vs.loading();
      service
        .getAll("fornecedor", {}, "/buscar-tipos-fornecedor")
        .then(({ data }) => {
          this.dados = data[0];
          this.$vs.loading.close();
        })
        .catch(e => {
          this.$vs.notify({
            position: "top-center",
            title: "Atenção",
            text: e,
            color: "danger"
          });
          this.$vs.loading.close();
        });
    }
  },

  mounted() {
    this.getDados();
  }
};
</script>
